import ModalComponent from '../ModalComponent/ModalComponent';
import classes from './Alert.module.css';
import {support_mail} from "../../../globals";
import {signal} from "@preact/signals-react";
import {useSignals} from "@preact/signals-react/runtime";


const ALERT_TYPES = {
    Error:"Error",
    Success:"Success",
    warning:"Warning",
    confirm:'Confirm'
}


const ALERT_HEADINGS={
    Error:"Error",
    Success:"Success",
    Warning:"Warning",
    confirm:''
}
const DEFAULT_CLOSE_TEXT = {
    Error:"Try Again",
    Success:"Close",
    warning:"Close",
    confirm:"Confirm"
}
export const alertArray = signal([]);

const AlertBox = ()=>{
    useSignals();

    return(
        <>
            {alertArray.value.map((alert,index)=>{
                let contactSupport = true; //for contact support text
                let contactSupportBtn = false; //for contact support btn
                let closeBtnText = "";
                let contactBtnText = "Contact Support";
                let alertText = alert.msg;
                switch(alert.type){
                    case ALERT_TYPES.Error:
                        closeBtnText = DEFAULT_CLOSE_TEXT.Error;
                        break;
                    case ALERT_TYPES.warning:
                        closeBtnText = DEFAULT_CLOSE_TEXT.warning;
                        break;
                    case ALERT_TYPES.confirm:
                        closeBtnText = DEFAULT_CLOSE_TEXT.confirm;
                        contactSupport=false;
                        contactSupportBtn=true;
                        contactBtnText="Cancel";
                        break;
                    default:
                        closeBtnText = DEFAULT_CLOSE_TEXT.Success;
                }

                let closeBtnAvailable = true;
                if(!!alert.config){
                    if(alert.config.contactSupport===false){
                        contactSupport = false;
                    }
                    contactSupportBtn = alert.config.contactSupportBtn;
                    closeBtnAvailable = !alert.config.noCloseBtn;
                    contactBtnText = alert.config.contactBtnText || contactBtnText;
                    closeBtnText = alert.config.closeBtnText || closeBtnText;
                }
                if(alert.type === ALERT_TYPES.Success){
                    contactSupport = false;
                }
                const isConfirmAlert = alert.type === ALERT_TYPES.confirm;
                const handleModalClose = () => {
                    const payload = {action_btn: ACTION_BTNS.CLOSE_ICON};
                    if (isConfirmAlert) {
                        alert.support(payload);
                        return;
                    }
                    alert.close(payload);
                };
                return (
                    <ModalComponent
                        key={index}
                        open={true}
                        alertMode={true}
                        isGenericAlert={true}
                        handleClose={handleModalClose}
                        handleFirstButton={()=>alert.close({action_btn:ACTION_BTNS.CLOSE_BTN})}
                        handleSecondButton={()=>alert.support({action_btn:ACTION_BTNS.SUPPORT_BTN})}
                        firstButton={closeBtnAvailable}
                        secondButton={contactSupportBtn}
                        modalHeader={ALERT_HEADINGS[alert.type]}
                        reverseBtnDirection={alert.type === ALERT_TYPES.confirm}
                        modalContent={(
                            <div data-testid={`${alert.type.toLowerCase()}-msg`} 
                            className={classes.alertMsgContainer}>
                                <p className={classes.alertMsg}>{alertText}</p>
                                {contactSupport?(
                                    <p className={classes.alertContactSupport}
                                       data-testid="contact-support-text">If you still are unable to perform an upload, please email:
                                        <br/><b>{support_mail}</b>
                                    </p>
                                ):null}
                            </div>
                        )}
                        firstButtonContent={closeBtnText}
                        secondButtonContent={contactBtnText}
                    />
                )
            })}
        </>
    )
}

export const ACTION_BTNS = {
    CLOSE_BTN:"close",
    CLOSE_ICON:"close_icon",
    SUPPORT_BTN:"support_btn"
}

export const Alert = ()=>{

    const hideModal = (index)=>{

        alertArray.value = alertArray.value.filter((_, i) => index !== i)
    }
    const alertHandler = (type,msg,config)=>{
        let resolve;
        let reject;
        let alertPromise =new Promise((res,rej)=>{
            resolve = (index,msg)=>{
                hideModal(index);
                res(msg);
            };
            reject = (index,msg)=>{
                if(config && config.withEmailTrigger){
                    const anchor = document.createElement("a");
                    anchor.setAttribute("href","mailto:"+support_mail.toLowerCase());
                    anchor.setAttribute("target","_blank")
                    anchor.setAttribute("style","display:none");
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);
                }
                hideModal(index);
                rej(msg);
            }
        });
        let currentIndex = alertArray.value.length;
        alertArray.value = alertArray.value.concat({
            type:type,
            msg:msg,
            config:config,
            close:(res)=>resolve(currentIndex,res),
            support:(res)=>reject(currentIndex,res),
        })


        return alertPromise;
    }

    return {

        error:(msg,config)=>alertHandler(ALERT_TYPES.Error,msg,config),
        success:(msg,config)=>alertHandler(ALERT_TYPES.Success,msg,config),
        info:(msg,config)=>alertHandler(ALERT_TYPES.Success,msg,config),
        warning:(msg,config)=>alertHandler(ALERT_TYPES.warning,msg,config),
        confirm:(msg,config)=>alertHandler(ALERT_TYPES.confirm,msg,config)
    }
}

export const AlertInstance = Alert();

export const AlertModal = AlertBox;
const alert = {
    error:AlertInstance.error,
    success:AlertInstance.success,
    info:AlertInstance.info,
    warning:AlertInstance.warning,
    confirm:AlertInstance.confirm
}

export default alert;
